import byCity from './byCity'
import create from './create'
import download from './download'
import update from './update'
import template from './template'

export default { byCity, create, download, template, update }
